<template>
  <main id="machine-sheet-handover">
    <div v-if="displayContent" class="handover">
      <!--
          <script
              type="text/javascript"
              src="https://d3js.org/d3.v3.js"></script>
      -->

      <div class="nav-handover">
        <div v-if="isPhone" class="sides-list-dropdown">
          <b-field>
            <b-select size="is-large" rounded v-model="selectedTab" @input="reloadTabs">
              <option
                  v-for="side in sides"
                  :value="side.name"
                  :key="side.name"
              >{{ side.values.name }}</option>
            </b-select>
          </b-field>
        </div>
        <div v-else class="sides-list-nav">
          <ul>
            <li v-for="side in sides" :key="side.name" :class="{'selected': selectedTab === side.name}">
              <a :href="'#' + side.name" @click="changeTab(side.name)">{{ side.values.name }}</a>
            </li>
          </ul>
        </div>


        <div class="buttons has-addons is-centered button-share" data-v-step='argument-12'>
          <button class="button is-primary is-rounded is-uppercase ml-0" :class="brandBackgroundColor"
                  @click="selectModal()">
            <span class="icon-download is-medium" :class="!isPhone ? 'is-left-side' : ''"></span>
            <span class="btn-text">{{ $t("handoverguide_sheet") }}</span>
          </button>

          <button class="button is-primary is-rounded is-uppercase ml-0 button-share" :class="brandBackgroundColor"
                  @click="selectModal(true)">
            <span class="icon-share is-medium has-text-centered icon-right"></span>
          </button>
        </div>
      </div>

      <div class="sides-list-content">
        <section v-for="side in sides" :key="side.name" v-if="selectedTab === side.name">
          <div class="slide-wrapper" v-for="slide in side.slides">
            <h2 class="title is-2">{{ slide.values.title }}</h2>
            <div class="container" :class="side.name + '-' + slide.id">
              <div class="handover-image loading" v-bind:id="'d3-' + side.name + slide.id"
                   :ref="side.name + '_' + slide.id">
                <!--            <img :src="slide.image" alt="Slide image" @load="reloadSlideEdition(slide)"/>-->
              </div>
              <div class="handover-hotspots">
                <ol>
                  <li class="hotspot-item" v-for="hotspot of slide.hotspots" :class="{'current': hotspot.order === 1}"
                      :id="'hotspot-' + hotspot.id">
                    <div class="circle">
                      <span>{{ hotspot.order }}</span>
                    </div>
                    <p v-if="hotspot.values.description" class="description">
                      {{ hotspot.values.description }}
                    </p>
                    <p v-if="hotspot.values.benefice" v-html="hotspot.values.benefice"></p>
                    <!--                  {{ $t('benefits') }} :-->
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="content-available-soon" v-else>
      {{ $t('content_in_loading') }}
    </div>
  </main>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import handoverService from '@/services/salesbox/handover';
import productService from '@/services/serli/product';
import * as d3 from "d3";
import SheetBlockAssociatedDocumentsSelect from "@/components/SheetBlock/SheetBlockAssociatedDocumentsSelect";
import {triggerTrackingEvent} from "@/common/helpers";

export default {
  name: 'MachineHandoverView',
  data() {
    return {
      data: null,
      sides: [],
      w: 1251,
      h: 800,
      selectedTab: null,
      displayContent: false
    }
  },
  computed: {
    ...mapState({
      productDatas: state => state.sheet.productDatas,
      isPhone: state => state.settings.isPhone,
    }),
    ...mapGetters({
      localeKebabFormat: 'settings/localeKebabFormat'
    }),
  },
  mounted() {
    // this.fetchGuideData();
    this.getGuideData();
  },
  methods: {
    async getGuideData() {
      if (this.productDatas.guide) {
        this.startLoading();
        // console.log('get data')
        await productService.getHandover(this.productDatas.identifier, {locale: this.localeKebabFormat})
          .then(response => {
            // this.sides = response.data;
            let indexTab = 0;
            if (response.data.data) {
              this.displayContent = true
              this.data = response.data.data;
              const attrToRemove = ['id', 'updated_at', 'published']
              for (let attr in this.data) {
                console.log(attr)
                if (!attrToRemove.includes(attr)) {
                  this.sides.push(this.data[attr]);
                  if (indexTab === 0) {
                    for (let slide of this.data[attr].slides) {
                      this.$nextTick(function () {
                        this.loadSlide(slide, attr);
                      })
                    }
                    this.selectedTab = this.data[attr].name;
                  }
                  indexTab++;
                }
              }
            }
          })
          .finally(() => this.stopLoading());
      }
    },
    fetchGuideData() {
      let indexTab = 0;
      this.data = this.productDatas.guide;
      const attrToRemove=['id','updated_at','published']
      for (let attr in this.data) {
        if (!attrToRemove.includes(attr)) {
          this.sides.push(this.data[attr]);
          if (indexTab === 0) {
            for (let slide of this.data[attr].slides) {
              this.$nextTick(function () {
                this.loadSlide(slide, attr);
              })
            }
            this.selectedTab = this.data[attr].name;
          }
          indexTab++;
        }
      }
    },
    loadSlide(data, name) {
      // console.log(d3);
      // const img = document.querySelectorAll("#d3-" + data.name + data.id + " img");
      const img = new Image();
      img.src = data.image;
      // @todo Fix error when loading on dynamic ref
      /*console.log(this.$refs);
      let reference = name + '_' + data.id;
      let loadingComponent = null;
      for (const ref in this.$refs) {
        if (ref === reference) {
          console.log(ref, 'is loading ...')
          loadingComponent = this.$loading.open({
            container: this.$refs[ref][0]
          });
        }
      }*/
      // console.log(img);
      img.onload = function () {
        const w = data.width,
            h = data.height;
        const svg = d3.select("#d3-" + name + data.id).append("svg")
            .attr("viewBox", `0 0 ` + w + ` ` + h);
        let jsonCircles = [];
        // console.log("#d3-" + data.id);
        data.hotspots.forEach(hotspot => {
          jsonCircles.push({id: hotspot.id, "x": hotspot.pos_x, "y": hotspot.pos_y, "text": hotspot.order})
        });
        data.subhotspots.forEach(hotspot => {
          jsonCircles.push({id: hotspot.parent_id, "x": hotspot.pos_x, "y": hotspot.pos_y, "text": hotspot.order})
        });
        // console.log(jsonCircles);
        const circles = svg.selectAll("circle")
            .data(jsonCircles)
            .enter()
            .append("circle");
        const circleAttributes = circles
            .attr("id", function (d) {
              return 'c' + d.id;
            })
            .attr("class", function (d) {
              return 'hotspot-point';
            })
            .attr("cx", function (d) {
              return d.x;
            })
            .attr("cy", function (d) {
              return d.y;
            })
            .attr("r", function (d) {
              return 20;
            })
            .style("fill", function (d) {
              return 'red';
            });
        const texts = svg.selectAll("text")
            .data(jsonCircles)
            .enter()
            .append("text");
        const textAttributes = texts
            .attr("id", function (d) {
              return 't' + d.id;
            })
            .attr("class", function (d) {
              return 'hotspot-text';
            })
            .attr("x", function (d) {
              return d.x;
            })
            .attr("y", function (d) {
              return d.y;
            })
            .attr('text-anchor', 'middle')
            .attr("dy", ".35em")
            .text(function (d) {
              return d.text;
            });

        const hotspots = document.querySelectorAll("#d3-" + name + data.id + " .hotspot-point, #d3-" + name + data.id + " .hotspot-text");
        // console.log(hotspots);
        hotspots.forEach(hotspot => {
          hotspot.onclick = function () {
            const currentText = document.querySelectorAll("." + name + "-" + data.id + " ol li.current")[0];
            // console.log(current)
            currentText.classList.remove('current');
            // console.log(hotspot.id);
            document.querySelectorAll("#hotspot-" + hotspot.id.slice(1))[0].classList.add('current');

            const current = document.querySelectorAll("#d3-" + name + data.id + " .hotspot-point.highlighted")[0];
            if (current) current.classList.remove('highlighted');
            let circleId = hotspot.id
            if (circleId.slice(0, 1) === 't') circleId = 'c' + circleId.slice(1);
            document.querySelectorAll("#" + circleId)[0].classList.add('highlighted')
          }
        });

        const hotspotDescs = document.querySelectorAll("." + name + "-" + data.id + " ol li");
        // console.log(hotspotDescs)
        hotspotDescs.forEach(text => {
          text.onclick = function () {
            const currentCircle = document.querySelectorAll("#d3-" + name + data.id + " .hotspot-point.highlighted")[0];
            if (currentCircle) currentCircle.classList.remove('highlighted');
            document.querySelectorAll("#c" + text.id.slice(8))[0].classList.add('highlighted');

            const current = document.querySelectorAll("." + name + "-" + data.id + " ol li.current")[0];
            current.classList.remove('current');
            document.querySelectorAll("#hotspot-" + text.id.slice(8))[0].classList.add('current');
          }
        })
        svg.style("background-image", function (d) {
          return `url(${data.image})`;
        });
      }
      console.log(this.$refs)
      this.$refs[name + '_' + data.id][0].classList.remove('loading');
      /*if (loadingComponent)
        loadingComponent.close();*/
    },
    changeTab(code) {
      this.startLoading();
      if (code !== this.selectedTab) {
        this.selectedTab = code;
        this.reloadTabs();
      }
      this.stopLoading();
    },
    reloadTabs() {
      for (let slide of this.data[this.selectedTab].slides) {
        this.$nextTick(function () {
          this.loadSlide(slide, this.selectedTab);
        })
      }
    },
    selectModal(mail = false, handoverPdf = true) {
      this.$buefy.modal.open({
        parent: this,
        component: SheetBlockAssociatedDocumentsSelect,
        hasModalCard: true,
        customClass: 'custom-class custom-class-2',
        trapFocus: true,
        width: 700,
        props: {docType: this.docType, mail: mail, handoverPdf: handoverPdf}
      })

      // triggerTrackingEvent(mail ? 'open_handover_guide_share_modal' : 'open_handover_guide_download_modal', 'click', `Ouverture de la popin d'obtention du guide de prise en main : ${this.productDatas.name} (${this.productDatas.identifier})`)
    }
  }
}
</script>

<style lang="scss">
#machine-sheet-handover {
  padding-top: 45px;
  padding-bottom: 40px;
  position:relative;

  .nav-handover {
    display: flex;
    width:100%;
    position:absolute;
    top:20px;

    @media #{$mq_phone} {
      display: inline-block;
      text-align: center;
    }
  }

  .sides-list-dropdown {
    max-width: 90%;
    width: auto;
    margin: 0 auto 20px;

    .select, .select select {
      width: 100%;
    }
  }

  .sides-list-nav {
    width: auto;
    display: inline-block;
    position: relative;
    margin: 0 auto 0 5%;
    border-radius: 35px;
    background-color: #EB1212;
    padding: 6px 0;
    overflow: hidden;
    max-width: 1920px;

    @media #{$mq_tablet}{
      width: 55%;
      //overflow-x: scroll;
    }

    @media #{$mq_phone} {
      width: auto;
      max-width: 90%;
      margin: 0 auto 8px;

      &:after {
        content: ">";
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 24px;
        top: 0;
        right: 0;
        height: 100%;
        width: 60px;
        opacity: 0.82;
        border-radius: 22.5px;
        background: linear-gradient(90deg, rgba(235, 18, 18, 0) 0%, #EB1212 100%);
        //visibility: hidden!important;
      }
    }

    ul {
      list-style: none;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-right: 6px;

      @media #{$mq_tablet} {
        overflow-x: auto;
      }
      /*!* width *!
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }

      !* Track *!
      &::-webkit-scrollbar-track {
        background: #b8b8b8;
      }

      !* Handle *!
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #333;
      }

      !* Handle on hover *!
      &::-webkit-scrollbar-thumb:hover {
        background: #000;
      }*/

      li {
        border-radius: 35px;
        color: #fff;
        padding: 8px 22px;
        //text-transform: capitalize;
        margin-right: 8px;
        white-space: nowrap;

        &:first-of-type {
          margin-left: 6px;
        }

        &:last-of-type {
          margin-right: 6px;
        }

        &.selected {
          background-color: #FFFFFF;
          color: #EB1212;
        }
      }
    }
  }

  .buttons {
    display: inline-block;
  }

  .button {
        &.mr-0 {
      margin-right: 0;
      //padding-right:0
    }

    &.ml-0 {
      margin-left: 0;
      padding-right: 1.1rem;
    }
  }

  .button-share {
    border-left: solid 2px #ffffff;
    margin-right: 76px;
    display: flex;
    flex-wrap: nowrap;

    @media #{$mq_tablet}{
      margin: 0 45px 0 25px;
    }
    @media #{$mq_phone}{
      margin: 0;
      justify-content: end;
      align-items: stretch;
      border-left: none;
    }

    & > .button-share {
      margin-right: 5%;

      @media #{$mq_phone}{
        margin-left: 10px !important;
      }
    }

    & > button {

      @media #{$mq_phone}{
        border-radius: 50% !important;
        width: 42px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0!important;
      }

      @media #{$mq_phone_min}{
        margin: 0 !important;
      }

      & > .btn-text {
        @media #{$mq_phone}{
          display: none;
        }
      }
    }

    .icon-share {
      line-height: 24px;
    }
  }

  .sides-list-content {
    width: 90%;
    margin: 35px auto 0;
    max-width: 1920px;

    @media #{$mq_phone} {
      margin-top: 54px;

      .slide-wrapper:first-of-type h2 {
        max-width: calc(100% - 120px);
      }
    }

    h2 {
      margin-bottom: 26px;
    }

    .container {
      margin: 0 0 50px;
      border-radius: 20px;
      background: radial-gradient(circle, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.09) 100%);
      display: flex;
      align-items: center;

      @media #{$mq_phone} {
        flex-wrap: wrap;

        & > div {
          flex-basis: 100% !important;
        }
      }

      & > div {
        flex: 1 0 50%;
        //max-width: 50%;
        padding: 20px 16px;
      }

      .handover-image.loading {
        background-image: url("~@/assets/img/loader.gif");
      }

      .handover-hotspots > ol {
        width: 90%;
        margin: 0 auto;
        //list-style: none;

        & > li {
          color: #020202;
          font-family: Roboto;
          font-size: 15px;
          letter-spacing: 0;
          line-height: 18px;
          border-bottom: solid 1px #000;
          margin-bottom: 10px;
          min-height: 42px;

          &.current {
            border-color: #EB1212;

            .circle {
              background: #EB1212;
            }
          }

          .circle {
            height: 30px;
            width: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #000;
            float: left;
            margin-left: -45px;
            border-radius: 30px;


            @media #{$mq_phone} {
              margin-left: -15px;
              margin-right: 10px;
            }
          }

          .circle span {
            color: #FFFFFF;
            font-family: Roboto;
            font-size: 13px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 15px;
            text-align: center;
          }

          & > p {
            margin: 4px 0 12px;
          }

          .description {
            font-weight: 700;
          }

          ul {
            list-style: disc;
            padding-left: 20px;

            li {
              margin: 4px 0;
            }
          }

          ol {
            list-style: decimal;
            padding-left: 20px;
            
            li {
              margin: 4px 0;
            }
          }

          a {
            text-decoration: underline;
          }
        }
      }

      svg {
        background-size: cover;

        circle, text {
          cursor: pointer;
        }

        text {
          font-family: Arial;
          font-size: 15px;
          stroke: #ffffff;
          fill: #ffffff;
        }

        circle.highlighted {
          stroke-width: 5px;
          stroke: #b8b8b8;
        }
      }
    }
  }
}
</style>
